import React, { Component } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';

import initializeFirebase from './App/initializers/firebase';
import initializeMoment from './App/initializers/moment';
import initializeNumeral from './App/initializers/numeral';
import initializeReduxStore from './App/initializers/reduxStore';

import SwitchAuthRoutes from './App/SwitchRoutes';
import RealtimeData from './App/RealtimeData';
import { actionCreators } from './actionCreators';

initializeMoment();
initializeNumeral();
initializeFirebase();

export const store = initializeReduxStore();

class App extends Component {
  constructor(props) {
    super(props);

    this.store = store;
  }

  componentWillMount() {
    this.observeAuth();
    this.observeNavigatorNetwork();
  }

  observeAuth() {
    this.store.dispatch(actionCreators.observeAuth());
  }

  observeNavigatorNetwork() {
    this.store.dispatch(actionCreators.updateApplicationNetworkState(window.navigator.onLine));
    window.addEventListener('offline', () => { this.store.dispatch(actionCreators.updateApplicationNetworkState(false)); });
    window.addEventListener('online', () => { this.store.dispatch(actionCreators.updateApplicationNetworkState(true)); });
  }

  render() {
    return (
      <Provider store={store}>
        <RealtimeData>
          <Router>
            <SwitchAuthRoutes />
          </Router>
        </RealtimeData>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js